import * as React from "react";
import { useTranslation } from "react-i18next";
import { Spinner } from "components/common";
import { TrafficGraphWithDaySelect } from "components/common/Graph";
import useDrawDownLicenseRemainingTraffic from "license/hooks/useDrawDownLicenseRemainingTraffic";
import useGraphDays from "components/common/Graph/contexts/useGraphDays";
const DrawDownLicenseVolumeGraph = () => {
  const { t } = useTranslation("enterprise_license");
  const { graphDays } = useGraphDays();
  const {
    isLoading: isLoadingDrawDownLicenseTraffic,
    isError: isErrorDrawDownLicenseTraffic,
    data: drawDownLicenseTrafficData
  } = useDrawDownLicenseRemainingTraffic(graphDays);
  if (isLoadingDrawDownLicenseTraffic) return /* @__PURE__ */ React.createElement(Spinner, null);
  if (isErrorDrawDownLicenseTraffic || !drawDownLicenseTrafficData) return null;
  return /* @__PURE__ */ React.createElement(TrafficGraphWithDaySelect, { title: t("license.metrics.remaining_volume"), traffic: drawDownLicenseTrafficData });
};
export default DrawDownLicenseVolumeGraph;
